import React from "react";

const InventoryClient = () => {
  return <div>InventoryClient</div>;
};

export default InventoryClient;
